$(function () {
    function debounce(func, wait) {
      let timeout;
      return function () {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    const $header = $('.site--header');
    const $topLevelLinks = $header.find('.top-level-link');
    const $rightNav = $('.right-menu li a');
    const $mediaWrapper = $('.media-content-wrapper');
    const $subnavLinks = $header.find('ul.main-submenu li a.subnav-link');
    const $megaMenuWrapper = $('.mega-menu-wrapper');

    function preloadImages() {
      $subnavLinks.each(function () {
        const img = new Image();
        img.src = $(this).data('src');
      });
    }
    preloadImages();

    $header.on('focus', '.top-level-link', function () {
      $topLevelLinks.removeClass('active').attr('aria-expanded', 'false');
    });

    $header.on('keydown', '.top-level-link', function (e) {
      if (e.key === 'Escape' || e.key === ' ') {
        e.preventDefault();
        const isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).toggleClass('active').attr('aria-expanded', !isExpanded);
        $(this).next($megaMenuWrapper).attr('aria-hidden', isExpanded);
        if (!isExpanded) {
          $(this).next($megaMenuWrapper).find('a, button').first().focus();
        }
      }
    });

    $header.on('mouseenter', '.top-level-link', debounce(function () {
      setMegaMenuMedia($(this));
    }, 100));

    $header.on('mouseenter', '.subnav-link', debounce(function () {
      setMegaMenuMedia($(this));
    }, 100));

    $header.on('mouseenter', '.third-subnav-link', debounce(function () {
      setMegaMenuMedia($(this));
    }, 100));

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        $topLevelLinks.removeClass('active').attr('aria-expanded', 'false');
      }
    });

    let submenuTimer;

    const submenuCache = {};

    function getSubmenu(id) {
      if (!submenuCache[id]) {
        submenuCache[id] = document.getElementById(id);
      }
      return submenuCache[id];
    }

    $rightNav.on('mouseenter', function () {
      const submenuId = this.getAttribute('aria-controls');
      const submenu = getSubmenu(submenuId);

      if (submenu) {
        const linkRect = this.getBoundingClientRect();
        const submenuList = submenu.querySelector('ul.main-submenu');

        if (submenuList) {
          clearTimeout(submenuTimer);
          submenuList.style.left = `${linkRect.left}px`;
          submenuList.classList.add('visible');
        }
      }
    });

    $rightNav.on('mouseleave', function () {
      const submenuId = this.getAttribute('aria-controls');
      const submenu = getSubmenu(submenuId);

      if (submenu) {
        submenuTimer = setTimeout(() => {
          const submenuList = submenu.querySelector('ul.main-submenu');
          if (submenuList) {
            submenuList.classList.remove('visible');
          }
        }, 50); 
      }
    });

    $(document).on('mouseenter', '.main-submenu', function () {
        clearTimeout(submenuTimer); // Cancel close timer
    });

    function setMegaMenuMedia(linkElement) {
      const src = linkElement.data('src');
      const alt = linkElement.data('alt') || '';
      const desc = linkElement.data('desc') || '';
      $mediaWrapper.css({
        'opacity': 1,
        'width': 'auto',
        'height': 'auto',
        'transition': 'all 0.3s ease-in-out'
      });
      let $img = $mediaWrapper.find('img');
      if ($img.length) {
        $img.attr('src', src).attr('alt', alt);
        $('.media-description').text(desc);
      } else {
        $mediaWrapper.html(`<img src="${src}" alt="${alt}"><div class="media-description"><p>${desc}</p></div>`);
      }
    }
  });